import { useState, useEffect, useCallback } from 'react'

export const useTabIndexes = (options: { autoplay?: boolean }) => {
  const { autoplay } = options
  const [tabIds, setTabIds] = useState<Array<string>>([])
  const [tabId, setTabId] = useState('')
  const [isPlaying, setIsPlaying] = useState(autoplay || false)

  const registerTab = useCallback((newTabId: string) => {
    setTabIds(tabIds => {
      if (tabIds.includes(newTabId)) {
        console.error(`Error: Tab with ID '${newTabId}' already exists.`)
        return tabIds
      }

      return [...tabIds, newTabId]
    })
  }, [])

  const unregisterTab = useCallback((removedTabId: string) => {
    setTabIds(tabIds => {
      return tabIds.filter(id => id !== removedTabId)
    })
  }, [])

  useEffect(() => {
    if (!tabId && tabIds.length > 0) {
      setTabId(tabIds[0])
    }
  }, [tabId, tabIds])

  useEffect(() => {
    setIsPlaying(autoplay || false)
  }, [autoplay])

  useEffect(() => {
    let timeout: number | undefined = undefined

    if (isPlaying) {
      timeout =
        window &&
        window.setTimeout(() => {
          const currentIndex = tabIds.findIndex(id => tabId === id)
          const nextId = tabIds[currentIndex + 1] || tabIds[0]
          setTabId(nextId)
        }, 3000)
    }

    return () => {
      if (timeout) {
        window && window.clearTimeout(timeout)
        timeout = undefined
      }
    }
  }, [isPlaying, tabIds, tabId])

  const onMouseEnter = useCallback(() => {
    if (autoplay) {
      setIsPlaying(false)
    }
  }, [autoplay])

  const onMouseLeave = useCallback(() => {
    if (autoplay) {
      setIsPlaying(true)
    }
  }, [autoplay])

  return { tabIds, tabId, registerTab, unregisterTab, setTabId, setTabIds, onMouseEnter, onMouseLeave }
}
